import { Box, Skeleton } from '@mui/material';
import HeaderFallback from './components/header.fallback';

const ProfileFallback = () => {
    return (
        <HeaderFallback title="پروفایل">
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    width: '100%',
                    height: '100%',
                }}>
                <Box
                    sx={{
                        width: { xs: '100%', md: '260px' },
                        height: { xs: '69px', md: '90%' },
                    }}>
                    <Skeleton
                        variant="rectangular"
                        width="100%"
                        height="100%"
                    />
                </Box>

                <Box
                    sx={{
                        width: '100%',
                        height: { xs: '82%', md: '90%' },
                        ml: { xs: 0, md: 2 },
                        mt: { xs: 2, md: 0 },
                    }}>
                    <Skeleton variant="rectangular" height="100%" />
                </Box>
            </Box>
        </HeaderFallback>
    );
};

export default ProfileFallback;
